var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: "",
                  inputLabel: _vm.$t("common.routing.config_name"),
                  placeholderValue: _vm.$t("common.routing.config_name"),
                },
                model: {
                  value: _vm.ConfigName,
                  callback: function ($$v) {
                    _vm.ConfigName = $$v
                  },
                  expression: "ConfigName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.bucket_name"),
                  placeholderValue: _vm.$t("common.routing.bucket_name"),
                },
                model: {
                  value: _vm.BucketName,
                  callback: function ($$v) {
                    _vm.BucketName = $$v
                  },
                  expression: "BucketName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.port"),
                  placeholderValue: _vm.$t("common.routing.port"),
                },
                model: {
                  value: _vm.Port,
                  callback: function ($$v) {
                    _vm.Port = $$v
                  },
                  expression: "Port",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  maxLength: 512,
                  inputLabel: _vm.$t("common.routing.uri"),
                  placeholderValue: _vm.$t("common.routing.uri"),
                },
                model: {
                  value: _vm.URI,
                  callback: function ($$v) {
                    _vm.URI = $$v
                  },
                  expression: "URI",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  maxLength: 512,
                  inputLabel: _vm.$t("common.routing.prefix"),
                  placeholderValue: _vm.$t("common.routing.prefix"),
                },
                model: {
                  value: _vm.Prefix,
                  callback: function ($$v) {
                    _vm.Prefix = $$v
                  },
                  expression: "Prefix",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  maxLength: 512,
                  inputLabel: _vm.$t("common.routing.region"),
                  placeholderValue: _vm.$t("common.routing.region"),
                },
                model: {
                  value: _vm.Region,
                  callback: function ($$v) {
                    _vm.Region = $$v
                  },
                  expression: "Region",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.secret_key"),
                  placeholderValue: _vm.$t("common.routing.secret_key"),
                },
                model: {
                  value: _vm.SecretKey,
                  callback: function ($$v) {
                    _vm.SecretKey = $$v
                  },
                  expression: "SecretKey",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.scheme"),
                  placeholderValue: _vm.$t("common.routing.scheme"),
                },
                model: {
                  value: _vm.Scheme,
                  callback: function ($$v) {
                    _vm.Scheme = $$v
                  },
                  expression: "Scheme",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.use_dual_stack"),
                  placeholderValue: _vm.$t("common.routing.use_dual_stack"),
                },
                model: {
                  value: _vm.useDualStack,
                  callback: function ($$v) {
                    _vm.useDualStack = $$v
                  },
                  expression: "useDualStack",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.max_connections"),
                  placeholderValue: _vm.$t("common.routing.max_connections"),
                },
                model: {
                  value: _vm.maxConnections,
                  callback: function ($$v) {
                    _vm.maxConnections = $$v
                  },
                  expression: "maxConnections",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.request_timeout_ms"),
                  placeholderValue: _vm.$t("common.routing.request_timeout_ms"),
                },
                model: {
                  value: _vm.RequestTimeoutMs,
                  callback: function ($$v) {
                    _vm.RequestTimeoutMs = $$v
                  },
                  expression: "RequestTimeoutMs",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.connect_timeout_ms"),
                  placeholderValue: _vm.$t("common.routing.connect_timeout_ms"),
                },
                model: {
                  value: _vm.ConnectTimeoutMs,
                  callback: function ($$v) {
                    _vm.ConnectTimeoutMs = $$v
                  },
                  expression: "ConnectTimeoutMs",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.enable_tcp_keep_alive"),
                  placeholderValue: _vm.$t(
                    "common.routing.enable_tcp_keep_alive"
                  ),
                },
                model: {
                  value: _vm.enableTcpKeepAlive,
                  callback: function ($$v) {
                    _vm.enableTcpKeepAlive = $$v
                  },
                  expression: "enableTcpKeepAlive",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t(
                    "common.routing.tcp_keep_alive_inverval_ms"
                  ),
                  placeholderValue: _vm.$t(
                    "common.routing.tcp_keep_alive_inverval_ms"
                  ),
                },
                model: {
                  value: _vm.tcpKeepAliveInvervalMs,
                  callback: function ($$v) {
                    _vm.tcpKeepAliveInvervalMs = $$v
                  },
                  expression: "tcpKeepAliveInvervalMs",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.low_speed_limit"),
                  placeholderValue: _vm.$t("common.routing.low_speed_limit"),
                },
                model: {
                  value: _vm.lowSpeedLimit,
                  callback: function ($$v) {
                    _vm.lowSpeedLimit = $$v
                  },
                  expression: "lowSpeedLimit",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.verify_ssl"),
                  placeholderValue: _vm.$t("common.routing.verify_ssl"),
                },
                model: {
                  value: _vm.VerifySSL,
                  callback: function ($$v) {
                    _vm.VerifySSL = $$v
                  },
                  expression: "VerifySSL",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.follow_redirects"),
                  placeholderValue: _vm.$t("common.routing.follow_redirects"),
                },
                model: {
                  value: _vm.FollowRedirects,
                  callback: function ($$v) {
                    _vm.FollowRedirects = $$v
                  },
                  expression: "FollowRedirects",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.disable_expect_header"),
                  placeholderValue: _vm.$t(
                    "common.routing.disable_expect_header"
                  ),
                },
                model: {
                  value: _vm.DisableExpectHeader,
                  callback: function ($$v) {
                    _vm.DisableExpectHeader = $$v
                  },
                  expression: "DisableExpectHeader",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t(
                    "common.routing.enable_clock_skew_adjustement"
                  ),
                  placeholderValue: _vm.$t(
                    "common.routing.enable_clock_skew_adjustement"
                  ),
                },
                model: {
                  value: _vm.EnableClockSkewAdjustement,
                  callback: function ($$v) {
                    _vm.EnableClockSkewAdjustement = $$v
                  },
                  expression: "EnableClockSkewAdjustement",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t(
                    "common.routing.enable_host_prefix_infection"
                  ),
                  placeholderValue: _vm.$t(
                    "common.routing.enable_host_prefix_infection"
                  ),
                },
                model: {
                  value: _vm.enableHostPrefixInfection,
                  callback: function ($$v) {
                    _vm.enableHostPrefixInfection = $$v
                  },
                  expression: "enableHostPrefixInfection",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t(
                    "common.routing.enable_endpoint_discovery"
                  ),
                  placeholderValue: _vm.$t(
                    "common.routing.enable_endpoint_discovery"
                  ),
                },
                model: {
                  value: _vm.enableEndpointdiscovery,
                  callback: function ($$v) {
                    _vm.enableEndpointdiscovery = $$v
                  },
                  expression: "enableEndpointdiscovery",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.access_key"),
                  placeholderValue: _vm.$t("common.routing.access_key"),
                },
                model: {
                  value: _vm.AccessKey,
                  callback: function ($$v) {
                    _vm.AccessKey = $$v
                  },
                  expression: "AccessKey",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.inputValue.Role != 1
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      disabled: _vm.inputValue.Role == 1 || _vm.readonly,
                      inputLabel: _vm.$t("common.routing.min_buffer_size"),
                      tooltipLabel:
                        _vm.inputValue.Role == 1
                          ? undefined
                          : _vm.$t("common.routing.min_buffer_output_size"),
                      placeholderValue: _vm.$t(
                        "common.routing.min_buffer_size"
                      ),
                    },
                    model: {
                      value: _vm.MinBufferSize,
                      callback: function ($$v) {
                        _vm.MinBufferSize = $$v
                      },
                      expression: "MinBufferSize",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _c("form-write-group-label-input", {
                attrs: {
                  isMandatory: "",
                  disabled: _vm.readonly,
                  inputLabel: _vm.$t("common.routing.max_buffer_size"),
                  tooltipLabel:
                    _vm.inputValue.Role == 1
                      ? _vm.$t("common.routing.max_buffer_size_input")
                      : _vm.$t("common.routing.max_buffer_size_output"),
                  placeholderValue: _vm.$t("common.routing.max_buffer_size"),
                },
                model: {
                  value: _vm.MaxBufferSize,
                  callback: function ($$v) {
                    _vm.MaxBufferSize = $$v
                  },
                  expression: "MaxBufferSize",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.inputValue.Role == 1
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("datetime-picker-custom", {
                    staticClass: "z-1",
                    class: {
                      "filter-item-input": true,
                      "filter-item-input-complete": _vm.BeginDate,
                    },
                    attrs: {
                      format: "DD/MM/YYYY H:i:s",
                      isMandatory: "",
                      inputLabel: _vm.$t("common.routing.begin_date"),
                      customInputParentClass: "filter-item-content",
                      customInputClass: "w-100",
                      maxLength: 19,
                      tooltipLabel:
                        _vm.inputValue.Role == 1
                          ? _vm.$t("common.routing.date_begin_input")
                          : undefined,
                      placeholderValue: _vm.$t(
                        "common.datetime_picker_empty_date"
                      ),
                      inputIcon: "fa-solid fa-calendar",
                      disabled: _vm.inputValue.Role == 0 || _vm.readonly,
                    },
                    model: {
                      value: _vm.BeginDate,
                      callback: function ($$v) {
                        _vm.BeginDate = $$v
                      },
                      expression: "BeginDate",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          false
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("datetime-picker-custom", {
                    staticClass: "z-1",
                    class: {
                      "filter-item-input": true,
                      "filter-item-input-complete": _vm.EndDate,
                    },
                    attrs: {
                      format: "DD/MM/YYYY H:i:s",
                      isMandatory: "",
                      inputLabel: _vm.$t("common.routing.end_date"),
                      customInputParentClass: "filter-item-content",
                      customInputClass: "w-100",
                      maxLength: 19,
                      placeholderValue: _vm.$t(
                        "common.datetime_picker_empty_date"
                      ),
                      inputIcon: "fa-solid fa-calendar",
                      disabled: "",
                    },
                    model: {
                      value: _vm.EndDate,
                      callback: function ($$v) {
                        _vm.EndDate = $$v
                      },
                      expression: "EndDate",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "form-accordion",
        { attrs: { title: _vm.$t("common.proxy"), isTitleUpperCase: false } },
        [
          _c(
            "b-row",
            { staticClass: "form-group" },
            [
              _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", { attrs: { for: "proxy-active" } }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("common.routing.proxy_active"))
                  ),
                  _c("span", { staticClass: "color-red" }, [_vm._v(" * ")]),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.proxyActive,
                        expression: "proxyActive",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { disabled: _vm.readonly, id: "proxy-active" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.proxyActive = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "1" } }, [
                      _vm._v(" " + _vm._s(_vm.$t("common.routing.yes")) + " "),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "0", selected: "" } }, [
                      _vm._v(" " + _vm._s(_vm.$t("common.routing.no")) + " "),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }),
              _vm._v(" "),
              _vm.proxyActive == "1"
                ? _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          disabled: _vm.readonly,
                          maxLength: 512,
                          inputLabel: _vm.$t("common.routing.proxy_scheme"),
                          placeholderValue: _vm.$t(
                            "common.routing.proxy_scheme"
                          ),
                        },
                        model: {
                          value: _vm.proxyScheme,
                          callback: function ($$v) {
                            _vm.proxyScheme = $$v
                          },
                          expression: "proxyScheme",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.proxyActive == "1"
                ? _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          disabled: _vm.readonly,
                          maxLength: 512,
                          inputLabel: _vm.$t("common.routing.proxy_host"),
                          placeholderValue: _vm.$t("common.routing.proxy_host"),
                        },
                        model: {
                          value: _vm.proxyHost,
                          callback: function ($$v) {
                            _vm.proxyHost = $$v
                          },
                          expression: "proxyHost",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.proxyActive == "1"
                ? _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          disabled: _vm.readonly,
                          maxLength: 512,
                          inputLabel: _vm.$t("common.routing.proxy_port"),
                          placeholderValue: _vm.$t("common.routing.proxy_port"),
                        },
                        model: {
                          value: _vm.proxyPort,
                          callback: function ($$v) {
                            _vm.proxyPort = $$v
                          },
                          expression: "proxyPort",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.proxyActive == "1"
                ? _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          disabled: _vm.readonly,
                          maxLength: 512,
                          inputLabel: _vm.$t("common.routing.proxy_login"),
                          placeholderValue: _vm.$t(
                            "common.routing.proxy_login"
                          ),
                        },
                        model: {
                          value: _vm.proxyLogin,
                          callback: function ($$v) {
                            _vm.proxyLogin = $$v
                          },
                          expression: "proxyLogin",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.proxyActive == "1"
                ? _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          disabled: _vm.readonly,
                          maxLength: 512,
                          inputLabel: _vm.$t("common.routing.proxy_pwd"),
                          placeholderValue: _vm.$t("common.routing.proxy_pwd"),
                        },
                        model: {
                          value: _vm.proxyPwd,
                          callback: function ($$v) {
                            _vm.proxyPwd = $$v
                          },
                          expression: "proxyPwd",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }